import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminMomentsCalendar = {
  show: async(props) => {
    const { default: CalendarPage } = await import('@/vue_widgets/admin/moments/calendar/index.vue')
    createVueApp(CalendarPage, { props })
  }
}
